import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { SunIcon, MoonIcon, WalletIcon } from './Icons';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isRegisterMode, setIsRegisterMode] = useState(false);
  const { login, register } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!username || !password) {
      setError('Please fill in all fields');
      setIsLoading(false);
      return;
    }

    if (isRegisterMode) {
      if (username.length < 3) {
        setError('Username must be at least 3 characters');
        setIsLoading(false);
        return;
      }
      if (password.length < 6) {
        setError('Password must be at least 6 characters');
        setIsLoading(false);
        return;
      }
    }

    const result = isRegisterMode 
      ? await register(username, password)
      : await login(username, password);
    
    if (!result.success) {
      setError(result.error || (isRegisterMode ? 'Registration failed' : 'Login failed'));
    }
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <button className="theme-toggle login-theme" onClick={toggleTheme}>
        {theme === 'light' ? <MoonIcon size={20} /> : <SunIcon size={20} />}
      </button>
      
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <WalletIcon size={48} />
          </div>
          <h1>Portfolio Tracker</h1>
          <p>Manage your wealth, track your growth</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="error-message">
              {typeof error === 'string' ? error : error?.message || error?.toString() || 'An error occurred'}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              autoComplete={isRegisterMode ? "new-password" : "current-password"}
            />
          </div>

          <button type="submit" className="login-btn" disabled={isLoading}>
            {isLoading 
              ? (isRegisterMode ? 'Creating account...' : 'Signing in...') 
              : (isRegisterMode ? 'Create Account' : 'Sign In')}
          </button>
        </form>

        <div className="login-footer">
          <p>
            {isRegisterMode ? (
              <>
                Already have an account?{' '}
                <button 
                  type="button" 
                  className="link-button"
                  onClick={() => {
                    setIsRegisterMode(false);
                    setError('');
                    setUsername('');
                    setPassword('');
                  }}
                >
                  Sign In
                </button>
              </>
            ) : (
              <>
                Don't have an account?{' '}
                <button 
                  type="button" 
                  className="link-button"
                  onClick={() => {
                    setIsRegisterMode(true);
                    setError('');
                    setUsername('');
                    setPassword('');
                  }}
                >
                  Create Account
                </button>
              </>
            )}
          </p>
        </div>
      </div>

      <div className="login-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  );
};

export default Login;
